/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { QuoteResponsePublicDto } from './QuoteResponsePublicDto';
export type PublicEOfferResponseDto = {
    /**
     * eOffer ID
     */
    id: string;
    /**
     * Quote ID
     */
    quoteId: string;
    /**
     * Ando quote ID
     */
    andoQuoteId: string;
    /**
     * eOffer status
     */
    status: PublicEOfferResponseDto.status;
    /**
     * Recipient name
     */
    recipientName?: string;
    /**
     * Expiration date
     */
    expiresAt: string;
    /**
     * Total premium
     */
    totalPremium?: number;
    /**
     * Total tax
     */
    totalTax?: number;
    /**
     * Admin fee
     */
    adminFee?: number;
    /**
     * Broker fee
     */
    brokerFee?: number;
    /**
     * Total (totalPremium + adminFee + brokerFee)
     */
    total?: number;
    /**
     * Creation timestamp
     */
    createdAt: string;
    /**
     * Quote
     */
    quote: QuoteResponsePublicDto;
    /**
     * Per-risk premium details from Ando response (JSON array)
     */
    riskPremiums?: Record<string, any> | null;
    /**
     * Payment status
     */
    paymentStatus?: string;
    /**
     * Payment frequency
     */
    paymentFrequency?: string;
    /**
     * True when eOffer acceptance succeeded but ANDO policy bind failed
     */
    bindFailed: boolean;
};
export namespace PublicEOfferResponseDto {
    /**
     * eOffer status
     */
    export enum status {
        DRAFT = 'DRAFT',
        SENT = 'SENT',
        VIEWED = 'VIEWED',
        PARTIALLY_COMPLETED = 'PARTIALLY_COMPLETED',
        BIND_FAILED = 'BIND_FAILED',
        ACCEPTED = 'ACCEPTED',
        DECLINED = 'DECLINED',
        EXPIRED = 'EXPIRED',
    }
}

